<template>
  <div>
    <div :style="{height: height}" ref="playerContainer" class="player-container"></div>

    <div v-if="!id" :style="{height: height}">
      <el-empty :image-size="80" description="无视频接入"></el-empty>
    </div>
  </div>
</template>

<script>
  import "./main.es.css";
  import {PuPlayer} from "@besovideo/webrtc-player";
  import $http from '../request';

  export default {
    props: {
      id: {
        type: String,
        default: '',
      },
      url: {
        type: String,
        default: '',
      },
      username: {
        type: String,
        default: '',
      },
      password: {
        type: String,
        default: '',
      },
      startToPlay: {
        type: Boolean,
        default: false,
      },
      height: {
        type: String,
        default: '200px',
      }
    },
    data() {
      return {
        player: null,
        videoFit: "fill",
      };
    },
    watch: {
      id(val) {
        this.$nextTick(() => {
          if (this.url && this.id) {
            this.login();
          }
        });
      }
    },
    created(){

    },
    mounted() {
      this.$nextTick(() => {
        if (this.url && this.id) {
          this.login();
        }
      });
    },
    methods: {
      login(){
        $http({
          url: this.url + "/bvcsp/v1/auth/login",
          method: 'post',
          data: {
            username: this.username,
            password: this.password
          }
        }).then((res) => {
          this.token = res.data.data.token;
          if (this.startToPlay) {
            setTimeout(()=>{
              this.startPlay();
            }, 500)
          }
        })
      },
      startPlay() {
        let $this = this;
        if (!$this.token || !$this.id) return;
        console.info($this.token, "444444444444444")
        const { instance } = PuPlayer({
          // (可选) 容器节点 注意一个容器内只能存在一个实例  当container为假值（包括false、null、undefined）时 将返回实例引用的dom节点 容器必须指定高度 参考高德地图
          container: $this.$refs.playerContainer,
          // 必填 设备选项
          puOption: {
            // 设备id
            id: $this.id,
            // 设备通道号
            index: 0,
          },
          // 必填 用户授权令牌
          token: $this.token,
          videoFit: $this.videoFit,
          // (可选) 双击是否全屏
          fullScreenOnDblclick: true,
          // (可选) 启用控制器
          enableController: true,
          apiPrefix: $this.url,
          onConnected: () => {
            console.log("onConnected 连接已建立");
          },
          onConnectedFailed: () => {
            console.log("onConnectedFailed 连接建立失败");
          },
          onClose: () => {
            console.log("onClose 连接已关闭（播放器关闭）");
          },
          onDisConnected: () => {
            console.log("onDisConnected  连接已关闭（服务器断开连接）");
          },
          onDestroy: () => {
            console.log("onDestroy 播放器实例已销毁");
          },
        });
        $this.player = instance;
        setTimeout(()=>{
          console.info($this.player, "5555555")
          $this.player.open();
        }, 2000)
      },
      open() {
        try {
          this.player.open();
        } catch (e) {
          console.log(e);
        }
      },
      destroy() {
        // destroy前会执行close
        if (this.player) {
          this.player.destroy();
        }
        this.player = null;
      },
    },
    destroyed() {
      this.destroy();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/video/BesoWebRTCVideo.vue